<template>
  <div class="hello">
    <div v-if="loader">
      <Loader/>
    </div>
    <div v-else class="survey-banner">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <survey v-if="survey.title" :survey="survey"></survey>
            <h3 class="text-center p-4" v-if="survey.isCompleted">{{isSuccess ? successMsg : savingMsg}}</h3>
            <h3 class="text-center p-4" v-if="isFailed">{{isFailed && failedMsg}}</h3>
            <div class="align-items-center d-flex justify-content-center" v-if="isHomePageButtonVisiable">
              <a class="button" href="/survey-list">{{goToHomeText}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-content">
      <section class="how-it-works conection-shap">
        <div class="container">
          
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import * as SurveyVue from "survey-vue";
import moment from 'moment'
import Api from "@/services/api"
// import "survey-vue/modern.css";


var Survey = SurveyVue.Survey;
// Survey.cssType = "modern";
Survey.cssType = "min";


SurveyVue.Serializer.addProperty("question", "tag:number");

export default {
  components: {
    Survey,
    Loader
  },
  data() {
    return {
      loader: true,
      survey: {},
      nextSurvey: {},
      language: "ja",
      step: 1,
      // personID: '',
      // doctorName: '',
      validate: false,
      isStartClicked: false,
      isHomePageButtonVisiable: false,
      isNextSurveyButtonVisiable: false,
      startButtonText: '開始',
      placeHolderText: 'あなたのIDを入力してください',
      requiredText: 'あなたのIDが必要です',
      goToHomeText: 'アンケート一覧ページへ',
      goToNextSurveyText: '次のアンケートへ',
      savingMsg: '結果を保存しています。。。',
      successMsg: '結果は正常に保存されました！',
      failedMsg: 'エラーが発生したため、結果を保存できませんでした。',
      surveyResult: {
        person_id: "",
        survey_id: "",
        answers: {

        }
      },
      userCompletedSurveys: [
        
      ],
      completed_at: '',
      survey_id: this.$route.params.survey_id,
      // survey8: '8',
      surveyId: '',
      isSuccess: false,
      isFailed: false,
    };
  },
  created () {
    setInterval(this.getNow, 1000)
    // this.$store.commit('setIsLoading', true);
    this.setLanguage(this.$store.state.siteLanguage);
    Api.get('/surveyForSurveyJS/'+this.survey_id)
      .then(response => {
        if(response) {
          this.loader = false;
          this.survey = new SurveyVue.Model(response.data);
          this.survey.locale = this.$store.state.siteLanguage;
          this.addOnAfterRender();
          this.addOnComplete();
          // this.$store.commit('setIsLoading', false);
          // console.log('survey details', JSON.stringify(this.survey))
        }
      })
      .catch(error => {
        // console.log(error)
      })
      .finally(()=>{
        
    })
  },
  computed: {
    SiteLanguage () {
      return this.$store.state.siteLanguage
    },
    personID () {
      // return this.$store.state.personId
      return localStorage.getItem('setPersonId')
    },
    numberOfSurvey () {
      return localStorage.getItem('numberOfSurvey')
    },
    doctorName () {
      return this.$store.state.doctorName
    },
    filler () {
      return this.$store.state.filler
    }
  },
  mounted() {
    if (localStorage.userCompletedSurveys) {
      this.userCompletedSurveys = JSON.parse(localStorage.userCompletedSurveys)
    }

  },
  watch: {
    SiteLanguage (newSiteLanguage, oldSiteLanguage) {
      this.setLanguage(newSiteLanguage);
    },
    userCompletedSurveys: {
      handler (newCompletedSurveys) {
        console.log('Completed survey array updated')
        localStorage.userCompletedSurveys = JSON.stringify(newCompletedSurveys)
      },
      deep: true,
    } 
  },
  methods: {
    addOnAfterRender() {
      this.survey.onAfterRenderQuestion.add(function (sender, options) {
        if(options.question.getType() === "file") {
            var input = options.htmlElement.querySelector("input");
            input.capture = "camera";
        }
      });
    },
    addOnComplete(){
      this.survey.onComplete.add((survey, options) => {
        this.surveyResult.person_id = this.personID;
        this.surveyResult.survey_id = this.survey_id;
        this.surveyResult.took_at = this.$route.query.took_at ? this.$route.query.took_at : moment().format("YYYY-MM-DD");
        // this.surveyResult.doctor_id = this.doctorName;
        // this.surveyResult.filler_id = this.filler;
        console.log('user is', this.personID)

        this.surveyResult.answers = survey.data;
        Api.post('/userSurvey', this.surveyResult)
        .then(response => {
          this.isHomePageButtonVisiable = true;
          this.isSuccess = true;
          if (this.survey_id == this.numberOfSurvey) {
            this.isNextSurveyButtonVisiable = false
          }
          else {
            this.isNextSurveyButtonVisiable = true
          }

          this.addCompletedSurvey()
        })
        .catch(error => {
          options.showDataSavingError(this.failedMsg);
          this.isFailed = true;
          console.log(error)
        })
      })
    },
    getNow () {
      const today = new Date();
      const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date +' '+ time;
      this.completed_at = dateTime;
    },
    addCompletedSurvey() {
      this.$store.dispatch('getUser', { userId: this.personID, loading: false })
        .then(res => {})
        .catch(err => {})
    },
    startNextSurvey () {
      let surveyId = Number(this.survey_id)
      surveyId += 1

      console.log('survey id count', JSON.stringify(surveyId))
      this.$router.push('/surveyDetails/' + surveyId) 
    },
    setLanguage(siteLanguage){
      this.survey.locale = siteLanguage
      if(siteLanguage==="ja"){
        this.startButtonText = "開始";
        this.placeHolderText = "あなたのIDを入力してください";
        this.requiredText = 'あなたのIDが必要です';
        this.goToHomeText = 'アンケート一覧へ';
        this.goToNextSurveyText = '次のアンケートへ'
        this.savingMsg = '結果を保存しています...';
        this.successMsg = '結果は正常に保存されました！';
        this.failedMsg = 'エラーが発生したため、結果を保存できませんでした。';
      }
      else{
        this.startButtonText = 'Start';
        this.placeHolderText = 'Please enter your ID';
        this.requiredText = 'Your ID is required';
        this.goToHomeText = 'Go to Home Page';
        this.goToNextSurveyText = 'Go to the next survey'
        this.savingMsg = 'The results are saving on the server...';
        this.successMsg = 'The results were saved successfully!';
        this.failedMsg = 'An error occurred and we could not save the results.';
      }
    }
  }
};
</script>

<style scoped>
.survey-banner {
  padding: 150px 90px 65px 90px;
}
</style>

<style lang="scss">
.iq-login-regi {
  padding: 0px;
  .iq-login {
    border: none;
  }
}
.progress-bar {
  background-color: #28a745;
}
.progress {
  width: 100% !important;
  height: 1.5rem !important;
  background-color: #E0E0E0;
}
.panel-footer {
  display: flex;
  justify-content: space-between;
  .sv_prev_btn {
    background-color: #f0831e;
    color: #fff;
  }
  .sv_next_btn {
    background-color: #28a745;
    color: #fff;
  }
  .sv_complete_btn {
    background-color: #28a745;
    color: #fff;
  }
}
div.sv_body.sv_completed_page{
  display: none;
}
</style>
